import React from 'react';
import Button from '../../global/Button';

interface CTAButton {
  title: string;
  href: string;
}

interface CTASectionProps {
  title: string;
  buttons: readonly CTAButton[];
  backgroundImage: string;
}

export const CTASection = ({
  title,
  buttons,
  backgroundImage,
}: CTASectionProps) => {
  return (
    <section className="pb-12">
      <div className="relative">
        <div className="relative py-12 md:p-20 border-t border-b border-[#DBDBDB] z-10">
          <div className="max-full mx-auto bg-orange relative">
            <img
              src={backgroundImage}
              alt="CTA Background"
              className="absolute top-0 left-0 w-full h-full object-cover opacity-30 mix-blend-color-dodge"
            />
            <div className="px-2 md:px-32 py-16 md:py-24 w-full">
              <h2 className="text-2xl lg:text-5xl font-medium text-center text-white mb-12">
                {title}
              </h2>
              <div className="flex flex-row gap-4 justify-center">
                <Button as="a" href={buttons[0].href} variant="primary">
                  {buttons[0].title}
                </Button>
                <Button as="a" href={buttons[1].href} variant="faded">
                  {buttons[1].title}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute left-0 right-0 top-0 border-b border-[#F4F4F4] h-12">
          <div className="absolute left-0 md:left-12 right-0 md:right-12 top-0 w-auto overflow-hidden">
            <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] w-full h-12" />
          </div>
        </div>
        <div className="absolute left-0 right-0 bottom-0 border-t border-[#F4F4F4] h-12">
          <div className="absolute left-0 md:left-12 right-0 md:right-12 bottom-0 w-auto overflow-hidden">
            <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] w-full h-12" />
          </div>
        </div>
        <div className="hidden md:block absolute top-0 bottom-0 left-0 border-r border-[#F4F4F4] w-12">
          <div className="absolute top-12 bottom-12 left-0 h-auto overflow-hidden">
            <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] h-full w-12" />
          </div>
        </div>
        <div className="hidden md:block absolute top-0 bottom-0 right-0 border-l border-[#F4F4F4] w-12">
          <div className="absolute top-12 bottom-12 right-0 h-auto overflow-hidden">
            <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] h-full w-12" />
          </div>
        </div>
      </div>
    </section>
  );
};
